import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Typography
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { doNavigateToProduct } from '../actions/products';
import { FormattedMessage, FormattedDate } from 'react-intl';
import { withNavigation } from '../actions/navigation';


const SuccessfulDialog  = ({open, navigateToSubscription, message, classes}) => (
  <Dialog
      PaperProps={{className:classes.paperStyle}}
      fullScreen={false}
      open={open}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">
        <FormattedMessage id='messagesDialog.wish.dialogTitle' /> 
      </DialogTitle>
      <DialogContent>
        <div style={{whiteSpace:'pre'}}>
          <FormattedMessage 
            id={message.content} 
            defaultMessage={'Unknown Error'} 
          />
          <Typography
            variant="caption"
            className={classes.captionColor}
            style={{marginTop:16}}>
            <FormattedMessage id='plan.label'/>
          </Typography>
          <Typography variant="subtitle2" >
              {message.subscription && message.subscription.plan && message.subscription.plan.name}
          </Typography>
          {
            message.subscription.currentPeriodEndDate &&
            <div>
              <Typography 
                variant="caption"
                className={classes.captionColor}
                style={{marginTop:8}}>
                <FormattedMessage id='subscription.currentPeriodEndDate.label' />
              </Typography>
              <Typography variant="subtitle2">
                <FormattedDate
                  value={message.subscription && message.subscription.currentPeriodEndDate} />
              </Typography>
            </div>
          }
        </div>
      </DialogContent>
      <DialogActions>
        {message.subscription && message.subscription.plan && message.subscription.plan.product &&
          <Button variant="contained" onClick={_ => doNavigateToProduct(message.subscription.plan.product)} color="primary">
            <FormattedMessage
              id="messagesDialog.button.goToProduct"
              values={{
                productName: message.subscription.plan.product.name
              }}
            />
          </Button>
        }
        <Button onClick={_ => navigateToSubscription(message.subscription.id)} color="primary">
          <FormattedMessage
            id="messagesDialog.button.goToSubscription"
          />
        </Button>
      </DialogActions>
    </Dialog>
);

export default withNavigation(SuccessfulDialog);


// WEBPACK FOOTER //
// ./src/components/SuccessfulDialog.js